export enum fuelType {
  ELECTRIC = 'Electric',
  PETROL = 'Petrol',
  DIESEL = 'Diesel',
  PLUG_IN_HYBRID = 'Plug-in Hybrid',
  HYBRID = 'Hybrid',
  NOT_DEFINED = 'Not defined',
  UNSPECIFIED = 'Unspecified',
}

export enum engineType {
  NOVC_HEV = 'NOVC_HEV',
}

const FUEL_TYPE_ALIASES: Record<string, fuelType> = {
  'Plug-in Hybrid (Petrol/Electric)': fuelType.PLUG_IN_HYBRID,
};

const CANONICAL_FUEL_TYPES = Object.values(fuelType).sort(
  (a, b) => b.length - a.length
);

export const normalizeFuelTypeName = (
  fuelTypeName?: string | null
): string | undefined => {
  if (!fuelTypeName) return undefined;

  const exactAlias = FUEL_TYPE_ALIASES[fuelTypeName];
  if (exactAlias) return exactAlias;

  const canonical = CANONICAL_FUEL_TYPES.find(
    (value) => value === fuelTypeName
  );
  if (canonical) return canonical;

  const prefixMatch = CANONICAL_FUEL_TYPES.find((value) =>
    fuelTypeName.startsWith(`${value} (`)
  );
  return prefixMatch ?? fuelTypeName;
};

export const PETROL_MHEV_LABEL = 'Petrol mHEV';

// The API reports mHEV engines as Hybrid; the brochure labels them Petrol mHEV.
export const getDisplayFuelTypeName = (fuelTypeName?: string | null) =>
  fuelTypeName === fuelType.HYBRID ? PETROL_MHEV_LABEL : fuelTypeName;
